module.exports = __webpack_public_path__ + "static/eatseverything_2-fc9e41a4eed7b60d4a890537f4e0f2f7.jpg";